/**
 * Welcome / landing slider — same order and assets as mobile ImageSlider.
 */

import slide1 from '../../images/welcome/first-slide.webp';
import slide2 from '../../images/welcome/second-slide.webp';
import slide3 from '../../images/welcome/welcomeDog3.webp';
import slide4 from '../../images/welcome/welcome-documents.webp';
import slide5 from '../../images/welcome/welcome-dairy.webp';
import slide6 from '../../images/welcome/welcome-team.webp';
import slide7 from '../../images/welcome/welcome-family.webp';
import slide8 from '../../images/welcome/welcome-medical-card.webp';

export const WELCOME_SLIDER_SLIDES = [
  { id: 'slide1', image: slide1 },
  { id: 'slide2', image: slide2 },
  { id: 'slide8', image: slide8 },
  { id: 'slide6', image: slide6 },
  { id: 'slide4', image: slide4 },
  { id: 'slide7', image: slide7 },
  { id: 'slide5', image: slide5 },
  { id: 'slide3', image: slide3 },
];

export const WELCOME_SLIDER_IMAGE_SOURCES = WELCOME_SLIDER_SLIDES.map((slide) => slide.image);
